import type { IntlShape } from "react-intl";
import type InputType from "../../Input/InputType";
import Plate from "../Plate";

/**
 * @deprecated Use `Polygon` instead
 */
export default class Hexagon extends Plate {
	public static code = "plate_hexagon";

	public getDimensionsString(input: InputType, intl: IntlShape): string | undefined {
		if (input.width !== undefined) {
			const { width } = this.formatInputs(input, intl);

			return `ø ${width}`;
		}
		return undefined;
	}
}
